import { Cityvu3DScene } from "./Cityvu3DScene";

export class LocalScene extends Cityvu3DScene {
    public updateScene(delta: number): void {
        super.updateScene(delta);
    }
}
